import { forwardRef, HTMLProps, ReactNode } from 'react';
import cx from 'classnames';

import styles from './Input.module.scss';

export type InputProps = HTMLProps<HTMLInputElement> & {
  invalid?: boolean;
  feedback?: string;
  before?: string | ReactNode;
  after?: string | ReactNode;
};

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ invalid, feedback, before, after, className, ...htmlProps }, ref) => (
    <div className={cx(styles.container, { [styles.invalid]: invalid }, className)}>
      {htmlProps.label && (
        <label className={styles.label} htmlFor={htmlProps.id}>
          {htmlProps.label}
        </label>
      )}
      <div className={styles.content}>
        {before && <div className={styles.before}>{before}</div>}
        <input ref={ref} type="text" {...htmlProps} />
        {after && <div className={styles.after}>{after}</div>}
      </div>
      {feedback && <span className={cx(styles.feedback, { [styles.error]: invalid })}>{feedback}</span>}
    </div>
  )
);

export default Input;
